const S365Util = {
  isInApp() {
    let ret = false
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('s365') !== -1) {
      ret = true
    }
    return ret
  },
  isInIosApp() {
    let ret = false
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('s365') !== -1 && userAgent.indexOf('iphone') !== -1) {
      ret = true
    }
    return ret
  }
}

export { S365Util }
